import React from 'react';
import BzmIcon from '../../../icons/BzmIcon';

/**
 * Custom toggle for the React Dropdown. It is needed just to have custom mark up.
 */
class WorkspaceToggle extends React.Component<any> {
  selectInputStyles = {
    cursor: 'pointer',
  };

  constructor(props: any, context: any) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e: any) {
    e.preventDefault();
    this.props.onClick(e);
  }

  render() {
    return (
      <a
        ref={this.props.innerRef}
        href="#"
        onClick={this.handleClick}
        style={this.selectInputStyles}
        className="nav-link"
      >
        {this.props.children}
        <BzmIcon variant={'icon-bzm-chevron-down'} className={'ml-3'} style={{ position: 'relative', top: '2px' }} />
      </a>
    );
  }
}

export default React.forwardRef((props, ref) => <WorkspaceToggle innerRef={ref} {...props} />);
